namespace TR {

    interface RouteParams extends ng.route.IRouteParamsService
    {
        ref :string;
        source :string;
        tripId :string;
        version :number;
    }

    export interface TrackingPixel {
        trackingLabel :string;
        url :string;
    }

    class BookingCompleteTracking {

        public pixels :string[];
        public pixelsWithTracking : TrackingPixel[] = [];

        constructor (
            private $scope: ng.IScope,
            private $routeParams: RouteParams,
            private $location: ng.ILocationService,
            private analytics: any,
            private authService: any,
            private basketService: any,
            private bookingCompleteTrackingService: Core.BookingCompleteTrackingService,
            private trackingPixelsService: any,
            private tripService: Core.TripService
        ) {
            this.initTracking();
        }

        public onPixelLoad(name :string) :void {
            this.trackingPixelsService.report('load', name);
        }

        public onPixelLoadError(name :string) :void {
            this.trackingPixelsService.report('error', name);
        }

        private initTracking() {
            const bookingRef = this.$routeParams.ref.split('|')[0]; //for multi bookings 1st id is good enough

            const setTrackingUrls  = (bookingRef, basket?) => {
                // some pixels require additional information sourced form basket, we will pass it as options object
                const options = {};
                if (basket) {
                    let cancellationPrefix = 'canxp_';
                    let offer = basket.h || basket.f;
                    options['cancellationProtectionRef'] = _.chain(offer.Options)
                        .filter(item => item.OptionId.indexOf(cancellationPrefix) > -1)
                        .head()
                        .get('OptionId')
                        .replace(cancellationPrefix, '')
                        .value();
                }

                //we have two sets of pixels doing slightly different things ones where we track
                //if they have loaded or errored and others where we do not track this
                if (this.trackingPixelsService.getAllProviderUrls !== undefined) {
                    const pixels = <TrackingPixel[]>this.trackingPixelsService.getAllProviderUrls(bookingRef, options);
                    this.pixels = _.map(_.filter(pixels, (p) => { return p.trackingLabel.length === 0; }), 'url');
                    this.pixelsWithTracking = _.filter(pixels, (p) => { return p.trackingLabel.length > 0;});
                }
            };

            //if we have come back from PayPal we need to do a little extra work recording conversion values etc...
            //ref: the full booking reference string e.g. TRN/1234567%7CEUF/11488101%7CPRK/123456%7CACM/123656
            const tripId = this.$routeParams.tripId || this.$location.search().tripId;

            if (tripId) {
                const bookingRefs = this.$routeParams.ref.split('|');

                return this.tripService.getTrip(tripId).then(trip => {
                    const user = this.authService.getUser();
                    return this.bookingCompleteTrackingService.trackConversion(
                        trip,
                        bookingRefs,
                        this.$routeParams.source,
                        user.Email,
                        null
                    ).then(() => this.basketService.completeWorkflow(bookingRefs, trip.BasketId))
                    .then(([basket]) => basket);
                })
                .then((basket) => {
                    let basketHasContent = _.reduce(basket.all, (bool, elem) => {
                        if(elem != null){
                            if((elem instanceof Array && elem.length > 0) || !(elem instanceof Array)){
                                return true;
                            }
                        }
                        return bool;
                    }, false);

                    if(basketHasContent){
                        //by this point setData on tracking pixel service would have been called
                        //so we can get the urls now.
                        setTrackingUrls(bookingRef, basket);
                    }
                });
            }
            else
            {
                if (!TRPCONFIG.Domain2.NewTransactionTracking) {
                    this.analytics.trackConversion();
                }
                setTrackingUrls(bookingRef);
            }
        }
    }

    angular.module('TR')
        .directive('bookingCompleteTracking',
            function() {
                return {
                    restrict: 'E',
                    replace: false,
                    scope: true,
                    template: `<img ng-repeat="url in bct.pixels"
                                    ng-src="{{url}}"
                                    width="1" height="1" style="position:absolute; bottom:0;" />
                                <img ng-repeat="pixel in bct.pixelsWithTracking"
                                     ng-src="{{pixel.url}}"
                                     name="{{pixel.trackingLabel}}"
                                     image-loader
                                     data-onload="bct.onPixelLoad(pixel.trackingLabel)"
                                     data-onerror="bct.onPixelLoadError(pixel.trackingLabel)"
                                     width="1" height="1" style="position:absolute; bottom:0;" />`,
                    controller: BookingCompleteTracking,
                    controllerAs: 'bct'
                };
            });
}
